import React from "react";
import { withTranslation } from "react-i18next";
import { withRouter, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import homeUseEffect from "./useEffect";
import '../src/assets/css/styles_head.css'
import "../src/assets/css/breakpoint.css";
//Sections
import Head from "../src/components/head/Index";
import SectionComeBeADriver from "../src/components/sections/section-come-be-a-driver";
import SectionEarnings from "../src/components/sections/section-earnings";
import SectionFollowYourRight from "../src/components/sections/section-follow-your-right";
import SectionFrequentlyAskedQuestions from "../src/components/sections/section-frequently-asked-questions";
import SectionKnowSigmobi from "../src/components/sections/section-know-sigmobi";
import SectionCectionPageOficial from "../src/components/sections/section-page-oficial";
import SectionRegistrationSteps from "../src/components/sections/section-registration-steps";
import SectionSocialSigmobi from "../src/components/sections/section-social-sigmobi";
import SectionVirtualOffice from "../src/components/sections/section-virtual-office";
import SectionYouAreADriver from "../src/components/sections/section-you-are-a-driver";
import Footer from "../src/components/footer/Index";
import '../src/assets/css/footer.css'

import PropTypes from "prop-types";
import { findByReferralCode } from "../../../store/ledger/actions";

import UILoadingAnim from "../../../components/UILoadingAnim";
/**
 * Landing page página inicial
 */
class Index extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      codigoReferencia: props.match.params.code || "Linkt-sigmobi"
    };
  }

  componentDidMount() {
    const code = this.state.codigoReferencia;


    homeUseEffect();
  }

  render() {
    const { data, loading } = this.props;

    const { codigoReferencia } = this.state;
    const url = `${
      process.env?.REACT_APP_API_URL || "https://app.sigmobi.com"
    }/indication/signup/${codigoReferencia}`;

    return (
      <React.Fragment>
  
          <div>
            <Head />

            <body className="home page-template page-template-elementor_canvas page page-id-75 elementor-default elementor-template-canvas elementor-kit-67 elementor-page elementor-page-75">
              <div
                data-elementor-type="wp-page"
                data-elementor-id="75"
                className="elementor elementor-75"
              >
                <SectionKnowSigmobi url={url} />
                <SectionRegistrationSteps url={url} />
                <SectionEarnings url={url} />
                <SectionCectionPageOficial url={url} />
                <SectionFollowYourRight url={url} />
                <SectionYouAreADriver url={url} />
                <SectionComeBeADriver url={url} />
                <SectionSocialSigmobi url={url} />
                <SectionFrequentlyAskedQuestions url={url} />
                <SectionVirtualOffice />
                <Footer />
              </div>
            </body>
           
          </div>
      
      </React.Fragment>
    );
  }
}

Index.propTypes = {
  t: PropTypes.any,
  history: PropTypes.any,
  loading: PropTypes.any,
  error: PropTypes.any,
  message: PropTypes.any,
  findByReferralCode: PropTypes.func,
  data: PropTypes.any,
  referral_code: PropTypes.any,
};

const mapStateToProps = state => {
  const { data, loading } = state.LedgerProfile;

  return {
    data,
    loading,
  };
};
export default withTranslation()(
  withRouter(
    connect(mapStateToProps, {
      findByReferralCode,
    })(Index)
  )
);

//export default withTranslation()(withRouter(connect(state => {return {}}, {})((Index))))
